import { useEffect, useState } from 'react';
import { Permission } from '@common/enums';
import { useAuthContextProvider } from '@common/hooks/auth/AuthContextProvider';
import { userScopeHasPermissions } from '@common/utils/auth/authUtils';

interface IUseActiveUserDataReturnProps {
  /**
   * Active user id. null - user is not authorized.
   * @default null
   */
  userId: number | null;
  /**
   * Indicate if user is internal.
   * @default false
   */
  isInternal: boolean;
}

/**
 * Common hooks to get info about active user data from auth context
 */
export const useActiveUserData = (): IUseActiveUserDataReturnProps => {
  const authContext = useAuthContextProvider();
  const [userId, setUserId] = useState<number | null>(null);

  useEffect(() => {
    if (!authContext.isLoading && authContext.isAuthenticated) {
      setUserId(authContext.userScope.user_id);
    }
  }, [authContext.isLoading, authContext.isAuthenticated]);

  return {
    userId,
    isInternal: authContext.userScope ? userScopeHasPermissions(authContext.userScope, Permission.InternalUser) : false,
  };
};
